
const PaletteIcon = () => (
	<svg viewBox="0 0 24 24" fill="currentColor" stroke="none">
		{/* Main palette shape - outlined */}
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 13.5997 21.5997 15.1116 20.8837 16.4525C20.4715 17.2623 19.584 18 18.5 18H15.5C14.1193 18 13 19.1193 13 20.5C13 20.7761 12.7761 21 12.5 21H12C6.47715 21 2 16.5228 2 12ZM12 3.5C7.30558 3.5 3.5 7.30558 3.5 12C3.5 15.9782 6.33625 19.2849 10.1115 20.2162C10.4339 18.4064 11.8255 17 13.5 17H18.5C19.0824 17 19.5285 16.6127 19.7413 16.1725C20.3581 15.0334 20.5 13.5469 20.5 12C20.5 7.30558 16.6944 3.5 12 3.5Z"
		/>

		{/* Color dots - outlined */}
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M7.25 8.5C7.25 7.5335 8.0335 6.75 9 6.75C9.9665 6.75 10.75 7.5335 10.75 8.5C10.75 9.4665 9.9665 10.25 9 10.25C8.0335 10.25 7.25 9.4665 7.25 8.5ZM9 8.25C8.86193 8.25 8.75 8.36193 8.75 8.5C8.75 8.63807 8.86193 8.75 9 8.75C9.13807 8.75 9.25 8.63807 9.25 8.5C9.25 8.36193 9.13807 8.25 9 8.25Z"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M6.25 13.5C6.25 12.5335 7.0335 11.75 8 11.75C8.9665 11.75 9.75 12.5335 9.75 13.5C9.75 14.4665 8.9665 15.25 8 15.25C7.0335 15.25 6.25 14.4665 6.25 13.5ZM8 13.25C7.86193 13.25 7.75 13.3619 7.75 13.5C7.75 13.6381 7.86193 13.75 8 13.75C8.13807 13.75 8.25 13.6381 8.25 13.5C8.25 13.3619 8.13807 13.25 8 13.25Z"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M11.25 15.5C11.25 14.5335 12.0335 13.75 13 13.75C13.9665 13.75 14.75 14.5335 14.75 15.5C14.75 16.4665 13.9665 17.25 13 17.25C12.0335 17.25 11.25 16.4665 11.25 15.5ZM13 15.25C12.8619 15.25 12.75 15.3619 12.75 15.5C12.75 15.6381 12.8619 15.75 13 15.75C13.1381 15.75 13.25 15.6381 13.25 15.5C13.25 15.3619 13.1381 15.25 13 15.25Z"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M13.25 7.5C13.25 6.5335 14.0335 5.75 15 5.75C15.9665 5.75 16.75 6.5335 16.75 7.5C16.75 8.4665 15.9665 9.25 15 9.25C14.0335 9.25 13.25 8.4665 13.25 7.5ZM15 7.25C14.8619 7.25 14.75 7.36193 14.75 7.5C14.75 7.63807 14.8619 7.75 15 7.75C15.1381 7.75 15.25 7.63807 15.25 7.5C15.25 7.36193 15.1381 7.25 15 7.25Z"
		/>
	</svg>
);

export default PaletteIcon;